import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I'm <span className="purple">Dinitha Lakmin Wickramasinghe </span>
            from <span className="purple">Colombo, Sri Lanka 🇱🇰</span>
            <br />
            I am currently an undergraduate student at NSBM Green University affiliated with University
            of Plymouth, United Kingdom.
            <br />
            I study BSc(HONS.) Computer Science degree,
            <br />
            As a passionate Computer Science student with a keen interest in Cross-Platform Mobile App Development, FullStack Web Development, Machine Learning & Artificial Intelligence. 
            <br />
            I enjoy creating innovative solutions and learning new technologies to stay ahead in the tech world.
             Additionally, I love Circuit Designing and Electronic Prototyping, exploring the intersection of hardware and software.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Electronic Prototyping
            </li>
            <li className="about-activity">
              <ImPointRight /> Circuit Designing
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing with Linux Systems
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Stay curious, keep coding, and let your creativity take flight! ☕"{" "}
          </p>
          <footer className="blockquote-footer">Dinitha.W</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
